/** Configurable wave preparation countdowns and early-launch economy. */
export interface WavePacingConfig {
  /** Preparation time before wave 1 at match start. */
  firstWavePrepSeconds: number
  /** Preparation time after each wave clear (not after the final wave). */
  betweenWavesPrepSeconds: number
  /** Bonus coins per remaining prep second when the player launches early. */
  earlyStartCoinsPerSecond: number
}

export const DEFAULT_WAVE_PACING: WavePacingConfig = {
  firstWavePrepSeconds: 15,
  betweenWavesPrepSeconds: 8,
  earlyStartCoinsPerSecond: 2
}

/** Deterministic early-start payout: floor(remainingSeconds × rate). */
export function computeEarlyStartBonus(remainingSeconds: number, rate: number): number {
  if (remainingSeconds <= 0 || rate <= 0) return 0
  return Math.floor(remainingSeconds * rate)
}

export function prepRemainingSeconds(totalSeconds: number, elapsedSeconds: number): number {
  return Math.max(0, totalSeconds - elapsedSeconds)
}

/** UI countdown display — ceil so partial seconds read as full seconds remaining. */
export function prepCountdownDisplaySeconds(remainingSeconds: number): number {
  if (remainingSeconds <= 0) return 0
  return Math.ceil(remainingSeconds)
}
